import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./A3BillingDetails.css";
import apiService from "../../Services/apiServices";

const A3BillingDetails = (props) => {
  const {setIsShowMaximumChat} = props
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  let data = JSON.parse(props?.item?.text);
  if (!data) return null;

  const { tabHeading, listOfHeadings = [], Data = [], buttons = [] } = data;

  const combined = listOfHeadings.map((heading, i) => ({
    label: heading,
    value: Data[i] ?? "-"
  }));

  const handleButtonClick = (btn) => {
    const sessionId = sessionStorage.getItem("inputSessionId");
    if (btn?.buttonName === "Send BMail/OSD") {
      apiService.sendMail(sessionId).then((res) => {
        let status = res?.data?.message || "Mail sent successfully!";
        setIsShowMaximumChat(true)
        setPopupMessage(status);
        setShowPopup(true);
      });
    } else {
      let boxNumber = localStorage.getItem("billingSelectedBox")
      localStorage.removeItem("billingSelectedBox")
      props?.addMessages(
        boxNumber,
        btn?.opcode,
        btn?.buttonName,
        btn?.buttonName
      );
    }
  };

  // Portal content
  const popupContent = (
    <div className="popup-overlay" onClick={() => setShowPopup(false)}>
      <div
        className="popup-box"
        onClick={(e) => e.stopPropagation()} // stop close when clicking inside
      >
        <p>{popupMessage}</p>
        <button className="popup-close" onClick={() => setShowPopup(false)}>
          Close
        </button>
      </div>
    </div>
  );

  return (
    <div className="a3billing-container">
      <h3
        style={{ fontSize: !props?.showMaximumChat && "13px" }}
        className="a3billing-heading"
      >
        {tabHeading}
      </h3>
      <div className="pack-buttons" style={{ marginTop: "16px" }}>
        {buttons.map((btn, i) => (
          <button
            key={i}
            className="btn-active action-tab"
            style={{
              fontSize: !props?.showMaximumChat && "11px",
              padding: !props?.showMaximumChat && "5px 8px"
            }}
            onClick={() => handleButtonClick(btn)}
          >
            {btn?.buttonName}
          </button>
        ))}
      </div>

      <div
        className="a3billing-content"
        style={{
          display: !props?.showMaximumChat && "contents",
          gridTemplateColumns: `repeat(${combined.length}, 1fr)`
        }}
      >
        {combined.map((item, idx) => (
          <div
            style={{
              alignItems: !props?.showMaximumChat && "start",
              padding: !props?.showMaximumChat && "8px"
            }}
            className="billing-item"
            key={idx}
          >
            <div
              style={{ fontSize: !props?.showMaximumChat && "12px" }}
              className="billing-label"
            >
              {item.label} :{" "}
              <span className="billing-value">{item.value}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Render popup through portal */}
      {showPopup && ReactDOM.createPortal(popupContent, document.body)}
    </div>
  );
};

export default A3BillingDetails;
